import React, { useState, useEffect, useMemo } from 'react';
import VerticalBarChart from '../components/VerticalBarChart';
import rndIntensityBySubsidiaryCompanies from './rnd_intensity_by_subsidiary_companies.service';
const RnDIntensitySubsidiary = _ref => {
  let {
    filteredBusinessUnits,
    selectedYears,
    companyId,
    selectedSubsidiaryCompanyIds
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const businessUnitsParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
        const yearsParam = selectedYears.join(',');
        const subsidiaryCompanyIdsParam = selectedSubsidiaryCompanyIds.join(',');
        const data = await rndIntensityBySubsidiaryCompanies.all(companyId, businessUnitsParam, yearsParam, subsidiaryCompanyIdsParam);
        const transformedData = Object.entries(data).map(_ref2 => {
          let [label, value] = _ref2;
          return {
            label,
            value: parseFloat(value)
          };
        });
        setChartData(transformedData);
      } catch (error) {
        console.error('Error fetching R&D Intensity data by subsidiary company:', error);
      }
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedYears, selectedSubsidiaryCompanyIds]);
  const intensityGroups = useMemo(() => {
    return chartData.map(d => {
      const title = d.label.length > 15 ? d.label.substring(0, 15) + '...' : d.label;
      return {
        title,
        cols: 1
      };
    });
  }, [chartData]);
  const percentageFormatter = value => `${value}%`;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card dashboard-card-group-chart"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "R&D Intensity"), /*#__PURE__*/React.createElement(VerticalBarChart, {
    data: chartData,
    showlables: true,
    showLegend: false,
    dataName: "",
    formatter: percentageFormatter,
    isPercentageData: true,
    colors: ['#00afef', '#0078b9', '#00b08b']
  }));
};
export default RnDIntensitySubsidiary;